import { useState } from "react";
import { SvgIcon } from "../../chat-list/ChatAvatar.tsx";
import { EMOJI_PALETTE, icons } from "../icons.ts";

type EmojiPickerProps = {
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onSelectEmoji: (emoji: string) => void;
};

export function EmojiPicker({ open, onToggle, onClose, onSelectEmoji }: EmojiPickerProps) {
  const [emojiCategory, setEmojiCategory] = useState(0);

  return (
    <div className="wa-emoji-anchor">
      <button
        className={`wa-icon-btn ${open ? "is-active" : ""}`}
        type="button"
        title="Emoji"
        aria-label="Emoji"
        onClick={onToggle}
      >
        <SvgIcon svg={icons.emoji} />
      </button>
      {open ? (
        <div className="wa-emoji-popover" role="dialog" aria-label="Selecionar emoji">
          <header className="wa-emoji-popover-head">
            <strong>Emojis</strong>
            <button className="wa-popover-close" type="button" aria-label="Fechar emojis" onClick={onClose}>x</button>
          </header>
          <div className="wa-emoji-tabs" role="tablist">
            {EMOJI_PALETTE.map((cat, idx) => (
              <button
                key={cat.label}
                type="button"
                role="tab"
                className={`wa-emoji-tab ${emojiCategory === idx ? "is-active" : ""}`}
                onClick={() => setEmojiCategory(idx)}
              >
                {cat.label}
              </button>
            ))}
          </div>
          <div className="wa-emoji-grid" role="listbox">
            {EMOJI_PALETTE[emojiCategory]?.emojis.map((emoji, idx) => (
              <button
                key={`${emoji}-${idx}`}
                type="button"
                className="wa-emoji-cell"
                title={emoji}
                onClick={() => onSelectEmoji(emoji)}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
